<template>
  <div>
    <div :key="index" class="product-single" v-for="(sku, index) in list">
      <a
        @click="jumpDetails(sku.item_id, sku.sku_id, sku.platform, sku.item_type)"
        class="jump-details"
        href="javascript:;"
      >
        <div class="sku-details">
          <div class="sku-img">
            <img v-lazy="skuImg(sku.pic_url)" />
          </div>
          <div class="sku-intro">
            <div class="sku-title" v-if="sku.platform_info">
              <sku-platform :platform="sku.platform_info"></sku-platform>
              {{sku.name}}
            </div>
            <sku-price :sku="sku"></sku-price>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import SkuPlatform from './SkuPlatform'
import SkuPrice from './SkuPriceChange'
import api from '../utils/api'
let flag = false
export default {
  name: 'productSingle',
  components: {
    SkuPlatform,
    SkuPrice
  },
  props: {
    list: {
      type: Array
    }
  },
  computed: {
    skuImg (img) {
      return (img) => {
        if (!img) return ''
        if (img.includes('?')) {
          return `${img}&x-oss-process=image/resize,w_350`
        } else {
          return `${img}?x-oss-process=image/resize,w_350`
        }
      }
    },
    rebate (sku) {
      return sku => {
        return sku.activity || sku.equity
      }
    }
  },
  methods: {
    /**
     * 跳转商品详情
     * @param(String) goodsid 商品id
     * @param(String) skuid  商品skuid
     * @param(String) paltform 平台标识
     */
    async jumpDetails (goodsid, skuid, platform, type) {
      if (flag) {
        return false
      }
      flag = true
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
.product-single {
  margin-top: 0.2rem;
  background-color: #fff;
  .sku-details {
    color: @base;
    .flex-between;
    position: relative;
  }
  .sku-img {
    width: 2.6rem;
    height: 2.6rem;
    img {
      object-fit: contain;
    }
  }
  .sku-intro {
    width: 4rem;
    height: 2.15rem;
    padding-right: 0.2rem;
    .flex-column-between;
    .sku-title {
      width: 4rem;
      font-size: @fz28;
      .ellipsis2;
    }
    .sku-tips {
      position: absolute;
      right: 0.2rem;
      bottom: 0.2rem;
      // width: 1.52rem;
      padding: 0 0.1rem;
      height: 0.48rem;
      border-radius: 30px;
      background-color: #ffeaef;
      font-size: @fz20;
      color: @price;
      .flex-center;
    }
  }
}
</style>
